export default __webpack_public_path__ + "static/media/eject.d540851b.svg";